'use client';

import { GridLayoutItem } from '@components/Layouts';
import { freddyTheme } from '@coolblue-development/freddy';
import React from 'react';

import { HeroCard } from './HeroCard';
import { ControlButtons, useVideoCapability, VideoCard } from './VideoCard';

export const HeroSection = ({ videoId }: { videoId: string | undefined }) => {
  const { shouldAttemptVideo, videoReady, videoWrapperRef } = useVideoCapability(videoId);

  return (
    <GridLayoutItem
      column='1/-1'
      paddingTop={false}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        display: 'grid',
        [freddyTheme.breakpoint.minWidth('lg')]: {
          gridTemplateColumns: 'repeat(12, 1fr)',
          alignItems: 'center'
        }
      }}
    >
      <VideoCard
        videoId={videoId}
        shouldAttemptVideo={shouldAttemptVideo}
        videoReady={videoReady}
        videoWrapperRef={videoWrapperRef}
      />
      <HeroCard />
      {videoReady && <ControlButtons />}
    </GridLayoutItem>
  );
};
